import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { AppRoutes } from "pages/constants/routes";
import { RootState } from "store";
import { UserState } from "store/userSlice";

import styles from "./Header.module.scss";
import { ReactComponent as ArrowNext } from "assets/misc/arrow_right.svg";
import { ReactComponent as Support } from "assets/icons/about_us.svg";
import { ReactComponent as Logo } from "assets/site/Logo_Black.svg";

interface HeaderProps {
  hideSignIn?: boolean;
}

const Header = ({ hideSignIn = false }: HeaderProps) => {
  const userState: UserState = useSelector((state: RootState) => state.user);
  // const { creditBalance } = useSelector((state: RootState) => state.payment);
  // const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  // const onLogOut = () => {
  //   dispatch(logout());
  //   navigate(AppRoutes.landing);
  // };

  return (
    <div className={styles.container}>
      <div className={styles.logo} onClick={() => navigate(AppRoutes.landing)}>
        <Logo />
      </div>
      <div className={styles.navigationContainer}>
        <div
          className={styles.navigationItem}
          onClick={() => navigate(AppRoutes.support)}
        >
          <Support width="24px" height="24px" />
          Support
        </div>
        {!userState.loggedIn ? (
          <>
            {!hideSignIn && (
              <Link to={AppRoutes.signin} className={styles.signInButton}>
                <span>Sign In</span>
                <ArrowNext width="12px" />
              </Link>
            )}
          </>
        ) : (
          <Link to={AppRoutes.landing} className={styles.signInButton}>
            <span>Return Home</span>
            <ArrowNext width="12px" />
          </Link>
        )}
        {/* {!userState.loggedIn ? (
          <>
            {!hideSignIn && (
              <Link to={AppRoutes.signin} className={styles.signInButton}>
                <span>Sign In</span>
                <ArrowNext width="12px" />
              </Link>
            )}
          </>
        ) : (
          <Menu>
            <MenuButton className={styles.userBadge}>
              <div className={styles.badgeContents}>
                <div className={styles.creditBox}>
                  <Credit width="16px" height="16px" />
                  <span>{creditBalance.toFixed(2)}</span>
                </div>
                <div className={styles.personBox}>
                  <Person width="16px" height="16px" />
                </div>
              </div>
            </MenuButton>
            <MenuItems className={styles.dropDown} anchor="bottom end">
              <MenuItem>
                <Link className={styles.dropDownItem} to={AppRoutes.credit}>
                  <TopUp />
                  <span>Top Up</span>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link className={styles.dropDownItem} to={AppRoutes.payment}>
                  <CreditCard />
                  <span>Payment Methods</span>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link className={styles.dropDownItem} to={AppRoutes.settings}>
                  <Settings />
                  <span>Settings</span>
                </Link>
              </MenuItem>
              <MenuItem>
                <div
                  className={`${styles.dropDownItem} ${styles.logout}`}
                  onClick={onLogOut}
                >
                  <LogOut />
                  <span>Log Out</span>
                </div>
              </MenuItem>
            </MenuItems>
          </Menu>
        )} */}
      </div>
    </div>
  );
};

export default Header;
